import Filter from './Filter.jsx';

export default Filter;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/Filter/index.js